import { EcoLife } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export const setTotalEconomicLife = createAction<{
  id: string;
  field: EcoLife;
  newValue?: number;
}>('setTotalEconomicLife');
